import { styled } from '@linaria/react';

import { layout, primitives, semantic, size, space } from '../../theme/tokens';

const ring = (color: string) => `inset 0 0 0 ${size.stroke['stroke-thick']} ${color}`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
`;

export const Cell = styled.div<{ $focused: boolean; $invalid: boolean; $disabled: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  background: ${(p) => (p.$disabled ? semantic.bg.disabled : 'transparent')};
  cursor: ${(p) => (p.$disabled ? 'not-allowed' : 'auto')};
  box-shadow: ${(p) =>
    p.$focused
      ? ring(semantic.border.selected)
      : p.$invalid
      ? ring(semantic.border.danger)
      : 'none'};

  &:focus-within {
    box-shadow: ${ring(semantic.border.selected)};
  }
`;

export const HostCell = styled(Cell)`
  padding: ${layout.inputPadding};
`;

export const Host = styled.div`
  width: 100%;
  height: ${primitives.size['size-600']};
`;

export const ErrorList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
`;
